<div id="overlay"></div>

<div id="container">
    <div class="firework"></div>
    <div class="firework"></div>
    <div class="firework"></div>
    <div class="firework"></div>
    <div class="firework"></div>
    <div fxLayout="column" fxLayoutAlign="center center">
        <button mat-icon-button (click)="closeDialog()" fxFlexAlign="end" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
        <p class="congrats">{{ "ACHIEVEMENT.CONGRATS" | translate }}</p>
        <img
            [src]="detail.achievement.settings.badgeUrl || 'assets/images/gamification/achievement.png'"
            alt="achievement_badge"
            fxLayoutAlign="center center"
        />
        <p class="achievement-name">{{ detail.achievement.name }}</p>
        <p class="total-points">+{{ detail.totalPoints }}pts</p>
    </div>
</div>
